import { createFileRoute, notFound } from "@tanstack/react-router";
import giftStyles from "../styles/gifts.css?url";
import { GiftClaim } from "../components/membership/gift-pages";
import { creatorPageHead, shellFrom, withStylesheet } from "../lib/head";
import { loadGift } from "../server/gifts";

/** A gift link (/join/gift/<code>): who sent it, their note, and claiming it. Private. */
export const Route = createFileRoute("/join/gift/$code")({
  loader: async ({ params }) => {
    const data = await loadGift({ data: params.code });
    if (data.kind === "missing") throw notFound();
    return data;
  },
  head: ({ matches, loaderData }) => {
    const shell = shellFrom(matches);
    if (!shell || !loaderData) return {};
    return withStylesheet(
      creatorPageHead(shell, {
        pathname: "/join/gift",
        title: `A gift membership | ${loaderData.creatorName}`,
        description: `A membership to ${loaderData.creatorName}, given as a gift.`,
        noindex: true,
      }),
      giftStyles,
    );
  },
  component: ClaimGift,
});

function ClaimGift() {
  const data = Route.useLoaderData();
  const { code } = Route.useParams();
  return <GiftClaim view={data} code={code} />;
}
